// ADayFoodsComponent.js
import { Col, Row, Card, Typography, Space } from 'antd';
import { CoffeeOutlined, SunOutlined, MoonOutlined, HomeOutlined, RestOutlined, CalendarOutlined, UserOutlined } from '@ant-design/icons';
import React from 'react';
import { ASectionFoodsComponent } from './ASectionFoodsComponent';

const { Text } = Typography;

const sectionStyles = {
    "سحری": { color: '#40514e', icon: <RestOutlined style={{ color: '#40514e' }} /> },
    "صبحانه": { color: '#ffc107', icon: <CoffeeOutlined style={{ color: '#ffc107' }} /> },
    "ناهار": { color: '#f58607fd', icon: <SunOutlined style={{ color: '#f58607fd' }} /> },
    "افطاری": { color: '#6f42c1', icon: <HomeOutlined style={{ color: '#6f42c1' }} /> },
    "شام": { color: '#301013ff', icon: <MoonOutlined style={{ color: '#301013ff' }} /> }
};

export const ADayFoodsComponent = ({
    setLoading,
    showMessage,
    reserve,
    day,
    reportMode = false,
    dayIndex // <<<<<<<<<<<<<<<< دریافت dayIndex
}) => {
    const maxUsers = reserve.reserve_Users?.length || 0;

    // تعریف رنگ‌های متناوب برای هدر
    const headerColors = {
        bgColor1: '#e6f7ff', // آبی روشن
        borderColor1: '#91d5ff',
        textColor1: '#1890ff',

        bgColor2: '#fffbe6', // زرد روشن
        borderColor2: '#ffe58f',
        textColor2: '#faad14'
    };

    // انتخاب رنگ‌ها بر اساس زوج یا فرد بودن dayIndex
    const currentHeaderColors = dayIndex % 2 === 0 ? {
        bgColor: headerColors.bgColor1,
        borderColor: headerColors.borderColor1,
        textColor: headerColors.textColor1
    } : {
        bgColor: headerColors.bgColor2,
        borderColor: headerColors.borderColor2,
        textColor: headerColors.textColor2
    };

    return (
        <Col
            xs={24}
            sm={24}
            md={12}
            lg={8}
            xl={8}
            key={day.id}
            style={{ paddingBottom: '20px' }}
        >
            <Card
                style={{
                    borderRadius: '8px',
                    height: '100%',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)',
                    border: `1px solid ${currentHeaderColors.borderColor}`, // استفاده از رنگ border متناسب
                }}
                bodyStyle={{ padding: '0px' }}
            >
                <div style={{
                    backgroundColor: currentHeaderColors.bgColor, // <<<<<<<< استفاده از رنگ پس‌زمینه متغیر
                    padding: '10px 15px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    borderRadius: '8px 8px 0 0',
                    marginBottom: '15px',
                    borderBottom: `2px solid ${currentHeaderColors.borderColor}`, // <<<<<<<< استفاده از رنگ border متغیر
                }}>
                    <Row justify="space-between" align="middle">
                        <Col span={8}>
                            <Space size="small">
                                <CalendarOutlined style={{ color: currentHeaderColors.textColor }} /> {/* <<<<<<<< رنگ آیکون */}
                                <Text style={{ fontSize: '14px', color: currentHeaderColors.textColor }}>{day.shamsiDay}</Text> {/* <<<<<<<< رنگ متن */}
                            </Space>
                        </Col>
                        <Col span={8}>
                            <Text style={{ fontSize: '14px', color: currentHeaderColors.textColor }}>{day.date_Shamsi}</Text> {/* <<<<<<<< رنگ متن */}
                        </Col>
                        <Col span={8}>
                            {maxUsers > 0 && (
                                <Space size="small">
                                    <UserOutlined style={{ color: currentHeaderColors.textColor }} /> {/* <<<<<<<< رنگ آیکون */}
                                    <Text style={{ fontSize: '12px', color: currentHeaderColors.textColor }}>
                                        {maxUsers} نفر
                                    </Text>
                                </Space>
                            )}
                        </Col>
                    </Row>
                </div>

                <div style={{ padding: '10px 15px' }}>
                    {/* ... ASectionFoodsComponent ها ... */}
                    <ASectionFoodsComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        day={day}
                        foodSectionId={0}
                        foodSectionTitle={"سحری"}
                        reportMode={reportMode}
                        sectionColor={sectionStyles["سحری"].color}
                        sectionIcon={sectionStyles["سحری"].icon}
                    />
                    <ASectionFoodsComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        day={day}
                        foodSectionId={1}
                        foodSectionTitle={"صبحانه"}
                        reportMode={reportMode}
                        sectionColor={sectionStyles["صبحانه"].color}
                        sectionIcon={sectionStyles["صبحانه"].icon}
                    />
                    <ASectionFoodsComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        day={day}
                        foodSectionId={2}
                        foodSectionTitle={"ناهار"}
                        reportMode={reportMode}
                        sectionColor={sectionStyles["ناهار"].color}
                        sectionIcon={sectionStyles["ناهار"].icon}
                    />
                    <ASectionFoodsComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        day={day}
                        foodSectionId={3}
                        foodSectionTitle={"افطاری"}
                        reportMode={reportMode}
                        sectionColor={sectionStyles["افطاری"].color}
                        sectionIcon={sectionStyles["افطاری"].icon}
                    />
                    <ASectionFoodsComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        reserve={reserve}
                        day={day}
                        foodSectionId={4}
                        foodSectionTitle={"شام"}
                        reportMode={reportMode}
                        sectionColor={sectionStyles["شام"].color}
                        sectionIcon={sectionStyles["شام"].icon}
                    />
                </div>
            </Card>
        </Col>
    );
};